export default "__VITE_ASSET__DEWuU1G$__"